import DateTime from './DateTime';
import I18nDateTime from './I18nDateTime';

export { DateTime as dateTime }; // use as function, need locale param.
export default I18nDateTime; // use as a componnet and not need locale param.
